export default __webpack_public_path__ + "static/media/premium-clock-icon-morgan.bf977269875d771f1192e09b9efc2bb1.svg";